module.exports = __webpack_public_path__ + "img/online-check.52d5219c.png";